import React, { FC, HTMLAttributes, useEffect, useState } from "react";
import "./style.scss";
import BranchCashInfo from "./branch-cash-info";
import CashManagementTable from "./cash-management-table";
import AddEditTransaction from "./add-edit-transaction";
import { useNavigate, createSearchParams, useSearchParams } from "react-router-dom";
// import { URLSearchParams } from 'url';

const CashManagement: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const [toggleAddEditTransaction, setToggleAddEditTransaction] = useState(false),
        [isEditMode, setIsEditMode] = useState(false),
        [trxnIdForToast, setTrxnIdForToast] = useState(""),
        [currentSelectedTrxnTypeId, setCurrentSelectedTrxnTypeId] = useState(""),
        navigateTo = useNavigate();
  
  const [searchParams, setSearchParams] = useSearchParams();
  const [transactiontype, setTransactiontype] = useState(searchParams.get('transactiontype'));

  useEffect(() => {
    if (transactiontype) {
      updateAddView(transactiontype);
    }
  }, [transactiontype]);

  const hideAddEdit = () => {
    setToggleAddEditTransaction(false);
    navigateTo({
      pathname: '/accounting/cash_management',
    });
  }
  
  const showEditTransaction = () => {
    setIsEditMode(true);
    setToggleAddEditTransaction(true);
    setCurrentSelectedTrxnTypeId("");
  };
  const updateAddView = (id:string) => {
    const params = { transactiontype: id };
    setToggleAddEditTransaction(true);
    setIsEditMode(false);
    setCurrentSelectedTrxnTypeId(id);
    navigateTo({
      pathname: '/accounting/cash_management',
      search: `?${createSearchParams(params)}`,
    });
  };
  return (
    <div
      className={`cash-management-container bg-white px-20 py-16 m-24 sm:p-0 sm:m-0 flex flex-col h-full`}
    >
      {((toggleAddEditTransaction && !isEditMode && currentSelectedTrxnTypeId) || (toggleAddEditTransaction && isEditMode && !currentSelectedTrxnTypeId)) ? (
        <AddEditTransaction
          hideAddEditTransaction={hideAddEdit}
          isEditMode={isEditMode}
          updateTrxnIdForToast={setTrxnIdForToast}
          currentSelectedTrxnTypeId={currentSelectedTrxnTypeId}
        />
      ) : (
        <>
          <BranchCashInfo />
          <CashManagementTable
            showAddTransactionView={updateAddView}
            showEditTransaction={showEditTransaction}
            trxnIdForToast={trxnIdForToast}
            resetTrxnIdForToast={setTrxnIdForToast}
          />
        </>
      )}
    </div>
  );
};

export default CashManagement;
